import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { LoggingService } from './logging.service';
import { AnswersWithUserId } from '../models/answersWithUserId';
import { Observable } from 'rxjs';
import { AnswerResponse } from '../models/answerResponse';

@Injectable({
  providedIn: 'root'
})
export class AnswerService {

  constructor(private httpClient : HttpClient, private apiService: ApiService,
              private loggingService : LoggingService) { }

  createAnswers(answersWithUserId : AnswersWithUserId) : Observable<any[]> {
    return this.httpClient.post<any[]>( 
          this.apiService.getUrl('answer'), answersWithUserId);
  }

  saveAnswersProgress(answersWithUserId : AnswersWithUserId) : Observable<AnswerResponse[]> {
    return this.httpClient.post<any[]>( 
          this.apiService.getUrl('answer/save'), answersWithUserId);
  }

  getAllAnswers(userId : number, assignmentId : number) : Observable<AnswerResponse[]> {
    const params = {
      userId : userId,
      assignmentId : assignmentId
    };
    return this.httpClient.get<AnswerResponse[]>( 
          this.apiService.getUrl('answer'), {params : params} );
  }
  
}
